/**
 * Экземпляр движка синхронизации.
 *
 * Живёт в `shared`, а не в `app`, потому что к нему обращаются и фичи
 * (typing в чате, подсказка active_chat), а импорт `features → app`
 * запрещён правилами слоёв (CLIENT_WEB.md §2.2).
 */
import type { SyncEngine } from './engine'

let instance: SyncEngine | null = null

export function setSyncEngine(engine: SyncEngine | null): void {
  instance = engine
}

/** Движок, если он уже запущен. До входа его нет — это нормально. */
export function syncEngine(): SyncEngine | null {
  return instance
}
